import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'

import { RegularSection } from '@/components/Layouts'
import { getImageData } from '@/utilites/getImageData'

const CARD_SX = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  borderRadius: 5,
  overflow: 'hidden',
  position: 'relative',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  height: '60vh',
}

const OVERLAY_BOX_SX = {
  position: 'absolute',
  width: '100%',
  minHeight: '20%',
  bottom: 0,
  left: 0,
  bgcolor: 'rgba(0, 0, 0, 0.5)',
  p: 2,
}

interface Card {
    title?: string
    subtitle?: string
    image?: string | Record<string, unknown>
}

interface Content {
    cards?: Card[]
}

interface S3_team_2Props {
    content?: Content
    blockName?:string
}

const Index = (props: S3_team_2Props) => {
    const { content = {} } = props
    const { cards = [] } = content
    return (
        <RegularSection aria-label='S3_team_2' >
            <Grid
                container
                spacing={4}
                sx={{ width: '100%' }}
            >
                {cards.map((card, index) => {
                    const { src } = getImageData(card.image)
                    return (
                    <Grid
                        key={'team-card-' + index}
                        size={{ xs: 12, md: 6, lg: 4 }}
                        sx={{
                            ...CARD_SX,
                            backgroundImage: `url(${src || '/img/img-160400.jpg'})`,
                        }}
                    >
                        <Box
                            sx={OVERLAY_BOX_SX}
                            display={'flex'}
                            flexDirection={'column'}
                        >
                            <Typography variant='subtitle2' color='white'>
                                {card.title}
                            </Typography>
                            <Typography variant='body2' color='white'>
                                {card.subtitle}
                            </Typography>
                        </Box>
                    </Grid>
                )
                })}
            </Grid>
        </RegularSection>
    )
}

export default Index
